module.exports = __webpack_public_path__ + "img/06e_Share_Gigya02.b8664c5b.jpg";